import { RequestProps } from '../store/types'
import { defaultPageSize } from './defaultPagination'

const defaultProps: RequestProps = {
  page: 0,
  size: defaultPageSize,
}

export default defaultProps
